<script setup>
import { computed, toRefs } from "vue";

const props = defineProps({
  modelValue: Array,
  items: { type: Array, required: true },
  label: { type: String, default: "Select" },
  onSelect: { type: Function, default: null },
  multiple: { type: Boolean, default: true },
  chips: { type: Boolean, default: true },
  blurCheck: { type: Function },
  errorMessages: { type: Function },
  isRequired: {type: Boolean, default: false }
});

const emit = defineEmits(["update:modelValue"]);

const value = computed({
  get: () => props.modelValue,
  set: (newValue) => emit("update:modelValue", newValue),
});

const handleUpdate = (value) => {
  emit("update:modelValue", value);
  if (props.onSelect) {
    props.onSelect(value);
  }
};

const { items, label } = toRefs(props);
</script>
<template>
  <v-autocomplete
    v-model="value"
    :multiple="multiple"
    :chips="chips"
    closable-chips
    clear-on-select
    return-object
    clearable
    item-title="name"
    item-value="id"
    :label="label"
    :items="items"
    variant="outlined"
    hide-details="auto"
    :menu-props="{ maxWidth: 0 }"
    :error-messages="errorMessages"
    @update:model-value="handleUpdate"
    @blur="blurCheck"
  >
    <template #label>
      {{ label }}
      <span
        v-if="isRequired"
        class="ml-1 red--text"
      >
        <strong> *</strong>
      </span>
    </template>
  </v-autocomplete>
</template>
